module.exports = __webpack_public_path__ + "img/fish.8514cfd6.png";